import React from 'react';
import PropTypes from 'prop-types';
import DocumentTitle from 'react-document-title';
import 'react-tabs/style/react-tabs.css';
import { connect } from 'react-redux';
import { resetErrorMessage, apTabChanged } from '../actions/internal';
import { loadAccountPlayer, loadDashboardFilters } from '../actions/partner';
import { get } from 'lodash';
import { getTitle } from '../selectors';
import { LoadingSpinner } from '../components/helpers/LoadingSpinner';
import TopNavBar from './nav/TopNavBar';
import SubNavBar from './nav/SubNavBar';
import AccountPlayerChartsContainer from './accountplayer/AccountPlayerChartsContainer';
import AccountPlayerContainer from './accountplayer/AccountPlayerContainer';
import AccountPlayerHeaderContainer from './accountplayer/AccountPlayerHeaderContainer';

class AccountPlayerPage extends React.Component {
  componentDidMount() {
    this.props.resetErrorMessage();
    this.props.loadDashboardFilters({source: 'init'});
    this.props.loadAccountPlayer(this.props.match.params, {source: 'init'});
  }

  onTabSelect = tabIndex =>  this.setState({ tabIndex })

  render() {
    if (!this.props.auth.isAuthChecked) return null;
    const { match, playerId, title } = this.props;
    let isLoading = playerId !== parseInt(match.params.id, 10);
    return (
      <DocumentTitle title={title}>
        <div>
          <TopNavBar />
          <SubNavBar />
          <div className='row'>
            { isLoading ?
              <div className='column u-margin-top--base'>
                <LoadingSpinner bgColor='light' />
              </div> :
              <div className="column">
                <AccountPlayerHeaderContainer />
                <div className="row u-margin-top--base">
                  <AccountPlayerContainer />
                  <div className='column small-12 medium-9'>
                    <AccountPlayerChartsContainer />
                  </div>
                </div>
              </div> }
          </div>
        </div>
      </DocumentTitle>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    playerId: get(state.accountPlayer.player, 'id', 0),
    title: getTitle(state.accountPlayer.player, 'name'),
  }
}

AccountPlayerPage.propTypes = {
  auth: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  playerId: PropTypes.number,
  title: PropTypes.string.isRequired,
  apTabChanged: PropTypes.func.isRequired,
  loadAccountPlayer: PropTypes.func.isRequired,
  loadDashboardFilters: PropTypes.func.isRequired,
  resetErrorMessage: PropTypes.func.isRequired,
}

export default connect(
  mapStateToProps,
  { apTabChanged, loadAccountPlayer,
    loadDashboardFilters, resetErrorMessage,
  })(AccountPlayerPage);
